// extracted by mini-css-extract-plugin
export default {"box":"index_box_Ceeiu","title_box":"index_title_box_YSJbw","pic_box":"index_pic_box_SQdX1"};